import { StyleSheet } from 'react-native';

import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  root: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  validationLabelError: {
    color: PALETTE.errorColor,
  },
  validationLabelSuccess: {
    color: PALETTE.validationPositive,
  },
});
